const subscriptionFR = {
    "view": {
        "table": {
            "title": "Votre Abonnement",
            "column": {
                "subscriptionTier": "Niveau d'Abonnement",
                "startDate": "Date de Début",
                "currentPeriodStart": "Début de la Période Actuelle",
                "currentPeriodEnd": "Fin de la Période Actuelle",
                "autoRenewal": "Renouvellement Automatique",
                "status": "Statut",
                "action": "Action"
            },
            "label": {
                "status_active": "Actif",
                "status_incomplete": "Incomplet",
                "status_incomplete_expired": "Incomplet Expiré",
                "status_unpaid": "Non Payé",
                "status_past_due": "En Retard",
                "status_cancelled": "Annulé",
                "status_expired": "Expiré"
            },
            "actionDropdown": {
                "label": {
                    "action": "Action"
                },
                "button": {
                    "enableAutoRenewal": "Activer le Renouvellement Automatique",
                    "upgradeSubscription": "Améliorer l'Abonnement",
                    "cancelSubscription": "Annuler l'Abonnement",
                    "resumeSubscription": "Reprendre l'Abonnement",
                    "retryPayment": "Réessayer le Paiement"
                },
                "message": {
                    "successSubscripionResumed": "Votre abonnement a été repris, votre compte sera mis à jour sous peu !",
                    "successSubscripionCancelled": "Votre abonnement a été programmé pour être annulé à la fin de la période !",
                    "successSubscripionAutoRenewalEnabled": "Votre abonnement a été programmé pour être renouvelé automatiquement à la fin de la période !",
                    "activeSubscription": "Vous avez déjà un abonnement actif",
                    "incompleteSubscription": "Vous avez un abonnement qui est Incomplet."
                }
            },
            "modal": {
                "button": {
                    "cancel": "Annuler",
                    "enableAutoRenewal": "Activer le renouvellement automatique",
                    "cancelSubscription": "Annuler l’abonnement"
                }
            }
        },
        "modal": {
            "enableAutoRenewal": {
                "header": "Activer le Renouvellement Automatique",
                "body": "Êtes-vous sûr de vouloir activer le renouvellement automatique pour votre abonnement ?"
            },
            "cancel": {
                "header": "Annuler l'Abonnement",
                "body": "Êtes-vous sûr de vouloir annuler votre abonnement ?"
            },
            "resume": {
                "header": "Reprendre l'Abonnement",
                "body": {
                    "description": "Êtes-vous sûr de vouloir reprendre l'abonnement ?",
                    "note": "<strong>Note :</strong> Le dernier tarif d'abonnement s'appliquera !"
                },
                "button": {
                    "cancel": "Annuler",
                    "resume": "Reprendre"
                },
                "message": {
                    "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
                }
            },
            "retryPayment": {
                "header": "Réessayer le Paiement de l'Abonnement",
                "body": {
                    "description": "Êtes-vous sûr de vouloir réessayer le paiement pour l'abonnement ?",
                    "note": "<strong>Note :</strong> Le dernier tarif d'abonnement s'appliquera !"
                },
                "button": {
                    "cancel": "Annuler",
                    "retry": "Réessayer"
                },
                "message": {
                    "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
                }
            }
        },
        "message": {
            "errorPaymentFailed": "Le paiement de l'abonnement a échoué, veuillez réessayer plus tard !",
            "errorCardExpired": "Votre carte a expiré. Veuillez ajouter un <1>moyen de paiement</1> valide par défaut et réessayer le paiement.",
            "errorNoPaymentMethod": "Vous n'avez ajouté aucun <1>moyen de paiement</1> à votre profil. Veuillez ajouter un <3>moyen de paiement</3> valide par défaut et réessayer le paiement.",
            "moduleNoAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations."
        }
    },
    "subscriptionTiers": {
        "form": {
            "title": "Choisissez Votre Plan",
            "button": {
                "startNow": "Commencer Maintenant"
            }
        },
        "message": {
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
        }
    },
    "upgrade": {
        "form": {
            "title": "Améliorez Votre Abonnement",
            "button": {
                "upgrade": "Améliorer",
                "currentPlan": "Plan Actuel"
            }
        },
        "modal": {
            "upgradeSubscription": {
                "header": "Améliorer l'Abonnement",
                "body": {
                    "description": "Êtes-vous sûr de vouloir améliorer votre plan d'abonnement à <strong>{{newTierName}}</strong>.",
                    "note": "<strong>Note : La période de facturation de l'abonnement restera inchangée et vous ne serez facturé que pour le montant excluant ce que vous avez déjà payé pour le plan existant.</strong>"
                },
                "button": {
                    "cancel": "Annuler",
                    "confirm": "Confirmer"
                }
            }
        },
        "message": {
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
            "moduleNoAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations."
        }
    },
    "confirmModal": {
        "header": "Confirmez Vos Informations",
        "body": {
            "form": {
                "label": {
                    "firstName": "Prénom",
                    "lastName": "Nom de Famille",
                    "country": "Pays de Résidence",
                    "refundPolicyAgreement": "En continuant, je reconnais et j’accepte que ce paiement est définitif et non remboursable. <1>Politique de remboursement</1>",
                },
                "help_text": {
                    "firstName": "Veuillez confirmer qu'il s'agit de votre Prénom Légal.",
                    "lastName": "Veuillez confirmer qu'il s'agit de votre Nom de Famille Légal.",
                    "country": "Veuillez spécifier votre pays de résidence actuel."
                },
                "message": {
                    "error": "Erreur survenue lors de la création de l'abonnement !",
                    "note": "Note : L'exactitude des informations que vous fournissez ici est essentielle pour les étapes suivantes. Assurez-vous que toutes les informations sont fournies avec précision et véracité."
                }
            }
        },
        "button": {
            "cancel": "Annuler",
            "confirm": "Confirmer"
        }
    },
    "upgradeFailure": {
        "view": {
            "title": "Échec de l'Amélioration de l'Abonnement :(",
            "description": "Il y a eu un problème lors de l'amélioration de votre abonnement. Veuillez réessayer plus tard !",
            "button": {
                "returnToDashboard": "Retour au Tableau de Bord"
            }
        }
    },
    "upgradeSuccess": {
        "view": {
            "title": "Abonnement Amélioré :)",
            "description": "Vous avez amélioré votre abonnement avec succès, votre compte sera mis à jour sous peu !",
            "button": {
                "returnToDashboard": "Retour au Tableau de Bord"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transaction Annulée :(",
            "description": "La transaction a été annulée... Veuillez réessayer plus tard !",
            "button": {
                "returnToDashboard": "Retour au Tableau de Bord"
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transaction Réussie :)",
            "description": "Vous avez confirmé votre abonnement avec succès, votre compte sera amélioré sous peu !",
            "button": {
                "returnToDashboard": "Retour au Tableau de Bord"
            }
        }
    }
};

export default subscriptionFR;